/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import { components } from "react-select";

const OrgDepositAccountCustomOption = ({ data, ...props }) => {
	const handleOnEdit = value => data.onEdit(value);

	return (
		<components.Option {...props}>
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<span>{data.label}</span>
				<If condition={data.editable}>
					<button
						type="button"
						className="btn btn-link"
						onClick={e => {
							e.stopPropagation();
							handleOnEdit(data.value);
						}}
					>
						<i className="rkf rkf-pencil" />
					</button>
				</If>
			</div>
		</components.Option>
	);
};

OrgDepositAccountCustomOption.propTypes = {
	data: PropTypes.object,
};

OrgDepositAccountCustomOption.defaultProps = {
	data: {},
};

export default OrgDepositAccountCustomOption;
